import script from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"
export * from "./GuideCTA.vue?vue&type=script&setup=true&lang=ts"

import "./GuideCTA.vue?vue&type=style&index=0&id=5cd7f5f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd7f5f2"]])

export default __exports__